define(function(require) {
    return {
        LAYER_ID : "GEO07E12_POINTS_SPES",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "INITIAL",
        TOKEN_REQUIRED: true,
        INDEX : 42,
        DATATABLE_ID : "t_GEO07E12_POINTS_SPES",
        QUERY_FIELDS : ["GUID", "CD_POSTL", "SECTEUR_SC1", "SECTEUR_SC2", "SECTEUR_SC3", "NBR_ELEVES"],
        FIELDS : [
            {ID : "GUID", NAME : "GUID", DATA_TYPE : "STRING", VALUE : "{{GUID}}"},
            {ID : "CD_POSTL", NAME : "Code postal", DATA_TYPE : "STRING", VALUE : "{{CD_POSTL}}"},
            {ID : "SECTEUR_SC1", NAME : "Secteur Scénario 1", DATA_TYPE : "STRING", VALUE : "{{SECTEUR_SC1}}"},
            {ID : "SECTEUR_SC2", NAME : "Secteur Scénario 2", DATA_TYPE : "STRING", VALUE : "{{SECTEUR_SC2}}"},
            {ID : "SECTEUR_SC3", NAME : "Secteur Scénario 3", DATA_TYPE : "STRING", VALUE : "{{SECTEUR_SC3}}"},
            {ID : "NBR_ELEVES", NAME : "Nombre d'élèves", DATA_TYPE : "NUMBER", VALUE : "{{NBR_ELEVES}}"},
            {ID : "THEME_SCENARIO_1", NAME : "THEME_SCENARIO_1", DATA_TYPE : "STRING", VALUE : "{{SECTEUR_SC1}}_{{SECTEUR_SC1}}"},
            {ID : "THEME_SCENARIO_2", NAME : "THEME_SCENARIO_2", DATA_TYPE : "STRING", VALUE : "{{SECTEUR_SC2}}_{{SECTEUR_SC2}}"},
            {ID : "THEME_SCENARIO_3", NAME : "THEME_SCENARIO_3", DATA_TYPE : "STRING", VALUE : "{{SECTEUR_SC3}}_{{SECTEUR_SC3}}"}
        ],
        STYLES : [
            {
                ID : "Élèves",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                        COLOR : "rgba(0,0,0,1)",
                        FONT_NAME : "CartoVistaCartographic",
                        FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                        SYMBOL_CHAR : "/",
                        SIZE : 10,
                        HAS_HALO : true,
                        HALO_COLOR : "rgba(0, 0, 0, 1)"
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Élèves",
            FEATURE_ID_DATACOLUMN : "GUID",
            FEATURE_NAME_DATACOLUMN : "CD_POSTL",
            DATATIP_DATACOLUMNS : ["CD_POSTL", "NBR_ELEVES"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_POSTL", "NBR_ELEVES"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_POSTL", "NBR_ELEVES"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            //SEARCHABLE_DATACOLUMNS : ["CD_POSTL"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NBR_ELEVES",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                OFFSET_X : 2,
                POSITION : "MIDDLE-RIGHT",
                PRIORITY : 10,
                VISIBLE : false
            },
            VISIBLE : true,
            ZOOM_ON_FEATURE_SCALE : 6000
        }
    };
});
